import React from 'react';
import Navbar from '../layout/Navbar';
import { ChevronDown } from 'lucide-react';
import cardiacImage from '../assets/CardiacSciences.jpeg';
import Footer from '../layout/Footer';

const CardiacSciences = () => {
  return (
    <div className="text-gray-800 bg-white">
      <Navbar />

      {/* Breadcrumb */}
      <div className="px-6 pt-6 text-sm text-blue-600">
        Home / Medical Specialities / Cardiac Sciences / ECMO
      </div>

      {/* Title */}
      <div className="px-6 py-6 space-y-4">
        <h1 className="text-4xl font-bold text-blue-800">ECMO</h1>
        <p className="max-w-4xl text-lg leading-relaxed text-gray-700">
          Extracorporeal membrane oxygenation (ECMO) is a life support machine that helps the heart and lungs work when a person is in critical condition...
        </p>
        <p className="max-w-4xl text-lg leading-relaxed text-gray-700">
          The ECMO machine replaces the function of the heart and lungs. People who need support from this machine are cared for in a hospital’s ICU...
        </p>
      </div>

      {/* Image Right + Info Left */}
      <div className="grid items-start grid-cols-1 gap-8 px-6 pb-10 md:grid-cols-3">
        {/* Info Section */}
        <div className="order-2 md:col-span-2 md:order-1">
          {/* Tabs */}
          <div className="flex mb-4 space-x-4 border-b border-gray-300">
  <button className="px-12 py-2 font-semibold text-white bg-[#009DA5] border-b-2 border-blue-700 rounded-t-xl">
    Details
  </button>
  <button className="px-12 py-2 font-semibold text-white bg-[#009DA5] border-b-2 border-blue-700 rounded-t-xl">
    Doctors
  </button>
</div>


          {/* Details Box */}
          <div className="p-6 shadow-sm bg-gray-50 rounded-xl">
            <h3 className="mb-4 text-xl font-semibold text-blue-800">What is ECMO used for:</h3>
            <ul className="pl-6 space-y-2 text-base text-gray-700 list-disc">
              <li>When lungs cannot provide enough oxygen even with ventilator.</li>
              <li>When organs cannot get rid of carbon dioxide effectively.</li>
              <li>When the heart cannot pump enough blood for the body.</li>
              <li>Temporary support during organ transplant wait (heart/lungs).</li>
            </ul>
          </div>
        </div>

        {/* Image Section */}
        <div className="order-1 md:col-span-1 md:order-2">
          <img
            src={cardiacImage}
            alt="ECMO monitor"
            className="w-full h-auto shadow-md rounded-2xl"
          />
        </div>
      </div>

      {/* FAQs */}
      <div className="px-6 pb-12">
        <h3 className="mb-6 text-2xl font-bold text-blue-800">FAQs</h3>
        <div className="space-y-4">
          {[
            'How does ECMO machine work?',
            'How is ECMO monitored?',
            'How long is the use?',
          ].map((faq, i) => (
            <div
              key={i}
              className="flex items-center justify-between p-4 transition bg-gray-100 cursor-pointer rounded-xl hover:bg-blue-50"
            >
              <span className="text-gray-800">{faq}</span>
              <ChevronDown className="text-gray-600" />
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CardiacSciences;
